import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import UserIcon from "../common/UserIcon";
import Store from "../../utils/Store";
import { get } from "lodash";
var UserBio = function UserBio(props) {
  var onLogout = props.onLogout;
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        user: store.user
      };
    }),
    user = _useStoreState.user;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex sm:hidden items-center justify-between p-4 border-b border-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement(UserIcon, {
    name: get(user, ["name"], "") || get(user, ["preferred_username"], ""),
    className: "h-8 w-8 text-lg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-center ml-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-base break-all"
  }, get(user, ["name"], "") || get(user, ["preferred_username"], "")), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-400 break-all"
  }, get(user, ["email"], "")), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-400 break-all"
  }, get(user, ["phone"], "")))), /*#__PURE__*/React.createElement("div", {
    className: "flex whitespace-nowrap text-gray-500 text-md font-bold py-3"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onLogout
  }, "LOG OUT")));
};
export default UserBio;